import { environment } from "@/shared/configs";

export const API_URL = "https://" + environment.VITE_APP_API + "/api/v1";

export const analyticsAvailablePeriods = ["hours", "days", "months", "years"] as const
export type AnalyticsAvailablePeriod = typeof analyticsAvailablePeriods[number]

export const licenseStatusList = ['ok', 'blocked', 'expired', 'tariff_expired', 'converted', 'free', 'warning', 'update_required'] as const
export type LicenseStatus = typeof licenseStatusList[number]


export const severityStatuses = ['ok', 'warning', 'critical', 'info'] as const
export type SeverityStatus = typeof severityStatuses[number]
